import React from 'react';

import { Icon } from '@chakra-ui/react';

export const ComplianceIcon = props => (
  <Icon
    viewBox="0 0 720 720"
    color="inherit"
    h="full"
    w="full"
    p="1px"
    {...props}
  >
    <g transform="translate(-492 -68)">
      <g>
        <path
          d="M582 563 672 563C695.077 563 714.098 580.37 716.697 602.753L717 608 717 698C717 721.076 699.628 740.098 677.248 742.699L672 743 582 743C558.923 743 539.902 725.63 537.303 703.247L537 698 537 608C537 584.924 554.372 565.902 576.752 563.301L582 563 672 563 582 563ZM1122 608C1146.85 608 1167 628.146 1167 653 1167 677.854 1146.85 698 1122 698L852 698C827.147 698 807 677.854 807 653 807 628.146 827.147 608 852 608L1122 608ZM672 608 582 608 582 698 672 698 672 608ZM672 338C696.853 338 717 358.147 717 383L717 473C717 497.853 696.853 518 672 518L582 518C557.147 518 537 497.853 537 473L537 383C537 358.147 557.147 338 582 338L672 338ZM1122 383C1146.85 383 1167 403.147 1167 428 1167 451.077 1149.63 470.098 1127.25 472.697L1122 473 852 473C827.147 473 807 452.853 807 428 807 404.923 824.372 385.902 846.752 383.303L852 383 1122 383ZM672 383 582 383 582 473 672 473 672 383ZM706.86 123.176C718.841 135.158 719.931 153.908 710.128 167.121L706.86 170.906 594.615 283.151C588.286 289.481 579.701 293.036 570.75 293.036 563.589 293.036 556.663 290.76 550.938 286.61L546.885 283.151 501.885 238.151C488.705 224.971 488.705 203.602 501.885 190.421 513.867 178.439 532.617 177.35 545.829 187.153L549.615 190.421 570.75 211.556 659.13 123.176C672.31 109.996 693.679 109.996 706.86 123.176ZM1122 158C1146.85 158 1167 178.147 1167 203 1167 226.077 1149.63 245.098 1127.25 247.697L1122 248 852 248C827.147 248 807 227.853 807 203 807 179.923 824.372 160.902 846.752 158.303L852 158 1122 158Z"
          fill="currentColor"
          fillRule="nonzero"
          fillOpacity="1"
        />
      </g>
    </g>
  </Icon>
);
